import c from "../common";
import metaData from "../../../data/metaData";

export default {
  retry: c.retry.chn,
  success: c.success.chn,

  processing: c.processing.chn,

  //functions
  BRerror: "BR 檔案上載失敗",
  LogoError: "Logo 檔案上載失敗",
  OtherError: "其他相片 檔案上載失敗",

  confirm: c.Confirm.chn,

  cancel: c.cancel.chn,
  add: c.add.chn,

  //form start
  mustwrite: c.mustwrite.chn,

  //function Button Opening Hour
  addNewTime: "新增營業時段",

  //IonHeader
  back: c.Back.chn,
  editData: "修改資料",
  clearDraft: "清除草稿",

  //Step Title
  step1: "基本",
  step2: "地址",
  step3: "Logo",
  step4: "其他相片",
  step5: "等待審核",

  //step 1
  ShopName: "商名",

  Website: "商店網址",
  ContactMain: "商店主要電話",

  OpeningHour: "營業時間",
  Section: "時段",

  intro: c.intro.chn,
  within150: "150 字內",

  location: c.location.chn,

  locationNull: "不屬於任何筍點",
  LT7: "駱駝漆大廈",

  category: c.category.chn,
  contactUsText: "(如所屬分類不在此列, 請聯絡我們" + metaData.offical.email.info + ")",

  //step2
  shopAddress: "分店地址",
  switchOrder: "修改",

  //step 3
  newLogo: "新增Logo",
  switchLogo: "切換Logo",
  limit1: "上限: 1張",
  proportion: "長寬比例: 1:1",

  //step 4
  newPhoto: "新增其他相片",
  limitReached: "已達4張上限",
  switchOrDelete: "更改順序 / 刪除",
  ConfirmPreview: "確定 & 預覽",

  limit4: "上限: 4張",
  proportion2: "長寬比例: 16:9",

  drag: "拖放",
  photoToSwitch: "圖案以更改順序",

  click: "點擊",
  photoTodelete: "圖案以刪除圖片",

  //step 5
  ApplicationSubmitted: "已提交申請",
  BackToFront: "返回",
  ApplicationNumber: "申請編號",
  haveBeenSubmitted: " 已提交, 我們將會審核您的申請.",
  FinalText: "申請已提交, 我們將會審核您的申請",

  //Footer
  "Save&Next": "儲存並下一步",
  complete: c.complete.chn,

  description_1: "請選擇最少一日",
  description_2: "請選擇最少一個營業時段",
};
